import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import { subjectTrackersQuery } from '../../queries/subjects';
import { ErrorScreen, Loading } from '../utils';
import SubjectWithTrackers from './SubjectWithTrackers';
import { EditorContext } from './EditorContext';
import { Group } from '../settings/group/types';
import { Tracker } from './types';
import { uniqBy } from 'lodash';

const EntryMeasurements: React.FC = () => {
  const { state } = useContext(EditorContext);
  const subjects = uniqBy(state.subjectDisplay, item => item.subjectId);

  return (
    <>
      {subjects.map(({ subjectId }) => (
        <Query
          query={subjectTrackersQuery}
          variables={{ id: subjectId }}
          key={`query-${subjectId}`}
        >
          {({ data, loading, error }) => {
            if (data && loading) {
              return <Loading />;
            }
            if (error) {
              return <ErrorScreen error={error.message} />;
            }

            const subject = data.subject;

            const ungroupedTrackers = subject.trackers.filter(
              (tracker: Tracker) => tracker.groups.length === 0
            );

            // Add ungrouped trackers as a group
            const groupIds = subject.groups.map((group: Group) => group.id);
            if (!groupIds.includes('subject-trackers')) {
              subject.groups = [
                ...subject.groups,
                {
                  id: 'subject-trackers',
                  name: `${subject.name}`,
                  trackers: ungroupedTrackers
                }
              ];
            }

            return (
              <div>
                <h3 className="f4 fw6 pb2 ma0 ">{subject.name}</h3>

                <SubjectWithTrackers
                  subject={data.subject}
                  data-testid={`subject-${subject.slug}-trackers`}
                  key={`blah-${subjectId}`}
                />
              </div>
            );
          }}
        </Query>
      ))}
    </>
  );
};

export default EntryMeasurements;
